import { useDataChange, useDataValue } from 'Simple/Data'
import { snakeCaseToHumanReadable } from 'Data/format.js'

export function useOnClick(props) {
  let changeSelected = useDataChange({
    context: 'selected',
    viewPath: props.viewPath,
  })

  let action = useDataValue({
    context: 'action_execution',
    viewPath: props.viewPath,
  })

  return function onClick() {
    changeSelected(action)
  }
}

export function getTabName(action_type) {
  return action_type === 'check_requirements'
    ? 'The following tasks are required before unseating the patient'
    : snakeCaseToHumanReadable(action_type)
}

export function addOne(index) {
  return index + 1
}

export function isCompletedOrSkipped(status) {
  return ['completed', 'skipped'].includes(status)
}
